'use client';

import _slicedToArray from "/codebuild/output/src2598/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
function useUncontrolled(_ref) {
  var value = _ref.value,
    defaultValue = _ref.defaultValue,
    finalValue = _ref.finalValue,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  var _useState = useState(defaultValue !== void 0 ? defaultValue : finalValue),
    _useState2 = _slicedToArray(_useState, 2),
    uncontrolledValue = _useState2[0],
    setUncontrolledValue = _useState2[1];
  var handleUncontrolledChange = function handleUncontrolledChange(val) {
    setUncontrolledValue(val);
    for (var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      payload[_key - 1] = arguments[_key];
    }
    onChange === null || onChange === void 0 || onChange.apply(void 0, [val].concat(payload));
  };
  if (value !== void 0) {
    return [value, onChange, true];
  }
  return [uncontrolledValue, handleUncontrolledChange, false];
}
export { useUncontrolled };